// extracted by mini-css-extract-plugin
module.exports = {"background":"Home_background__S2kF1"};